import useQueryURL from "../../../common/hooks/useQueryURL";
import { Filter, OrderByType, useGenericAPI, useSingleGenericAPI } from "../../../utils/genericAPI/useGenericAPI";
import { useAuth } from "../../auth/hooks";
import { PAYGO_API_BASE_URL } from "../services/paygoAPI";
import { Paygo, PaygoPatch, PaygoRequest } from "../types/paygo.types";

/**
 * use Paygo
 * Method to get all paygo
 * @param param0 
 * @returns 
 */
export function usePaygo(params?:{
    pageSize?: number;
    orderBy?: OrderByType<Paygo>;
    preFilter?: Filter<Partial<Paygo>>;
}) {


    const {setHeaderAuthToRequest} = useAuth();
    setHeaderAuthToRequest();

    const { getAllQuery, createNew} = useGenericAPI<Paygo, PaygoRequest, PaygoPatch>({
        baseURL: PAYGO_API_BASE_URL,
        APIname: "paygos",
        pageSize: params?.pageSize,
        orderBy:params?.orderBy,
        preFilter: params?.preFilter
    })
    
  return {
    allPaygoQuery: { ...getAllQuery },
    createNewPaygoQuery: {
      ...createNew,
    },
  }
}

/**
 * useSinglePaygo
 * @param id 
 * @returns 
 */
export function useSinglePaygo(id?: string) {
    const {getQueryValue} = useQueryURL()
    const payGoIdQuery = getQueryValue("paygoId");
    const idFound = id || payGoIdQuery || undefined;
    if (!idFound) {
       console.error("You must provide an id to useSinglePaygo");
    }
    const {setHeaderAuthToRequest} = useAuth();
    setHeaderAuthToRequest();

    const {updateQuery, deleteQuery, singleQuery, patchQuery} = useSingleGenericAPI<Paygo, PaygoPatch>({
        baseURL: PAYGO_API_BASE_URL,
        APIname: "paygos",
        id: idFound
    })

    return {
        singlePaygoQuery: {...singleQuery},
        updatePaygoQuery: {...updateQuery},
        deletePaygoQuery: {...deleteQuery},
        patchPaygoQuery: {...patchQuery}
    }
}
export type PaygoAnalysisResult = {
  total: number
}

export const useGetSumKwhPayGoAnalysis = (config?: {preFilter?: Filter<Partial<Paygo>> }) => {


  

    const {getAllQuery } = useGenericAPI<PaygoAnalysisResult, null, PaygoPatch>({

        baseURL: PAYGO_API_BASE_URL+"/analysis/sumKwh",
        APIname: "paygos-sumKwh",
        
        preFilter: config?.preFilter,
       
    })



    return {
        sumKwhPaygoAnalysisQuery: {
            ...getAllQuery,
        }
    }
}